/* ============================================================
   REGINA – Warenkorb: Gutschein-Einlösung
   assets/section-cart-footer.js
   ------------------------------------------------------------
   Nutzt Shopifys offiziellen Rabattcode-Weg (/discount/CODE) statt
   einer selbstgebauten Validierung – das garantiert, dass jeder im
   Adminbereich angelegte Rabattcode zuverlässig funktioniert, ohne
   eigene Fehlerquellen. Kurzer Ladezustand für Rückmeldung, da ein
   Seitenaufruf nötig ist (Shopifys einzige zuverlässige Methode).
   ============================================================ */
(function () {
  document.querySelectorAll('[data-discount-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[name="discount"]');
      var btn = form.querySelector('.c-discount-btn');
      if (!input || !input.value.trim()) return;

      var code = input.value.trim();
      if (btn) {
        btn.disabled = true;
        btn.textContent = '…';
      }
      // Shopifys offizieller Einlöse-Weg: wendet den Code aufs aktuelle
      // Sitzungs-/Warenkorb an und leitet zurück zum Warenkorb.
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/cart');
    });
  });
})();
